import { Phone, Bike, MapPin } from "lucide-react";
import { formatPhoneNumber } from "../../lib/pedidoFormatters";
import { seloTipoEntrega } from "../../lib/tipoEntregaSelo";

/** Card com cliente, telefone (WhatsApp), entregador, endereço e badge de entrega. */
export function PedidoClienteEndereco({ pedido }) {
  const isMesa = pedido.modulo === "Mesas" || pedido.mesa_id;
  const cli = pedido.cliente || {};
  const end = pedido.endereco || null;
  const isDelivery = pedido.tipoEntrega === "delivery";
  // Balcão/Totem e Comandas não são "Entrega" (antes caíam no else).
  const selo = seloTipoEntrega(pedido);

  return (
    <div className="bg-muted/30 rounded-lg p-2.5 space-y-2">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-sm">{cli.nome || "Cliente"}</p>
          {cli.telefone && (
            <a
              href={`https://wa.me/${String(cli.telefone).replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-green-600 hover:underline flex items-center gap-1 mt-0.5"
            >
              <Phone className="w-3 h-3" /> {formatPhoneNumber(cli.telefone)}
            </a>
          )}
        </div>
        {pedido.entregador_nome && (
          <div className="text-right shrink-0">
            <p className="text-[10px] text-muted-foreground">Entregador</p>
            <p className="text-xs font-medium flex items-center gap-1 justify-end">
              <Bike className="w-3 h-3" /> {pedido.entregador_nome}
            </p>
          </div>
        )}
      </div>

      {isDelivery && end && (
        <div className="flex items-start gap-1.5 pt-1.5 border-t border-muted">
          <MapPin className="w-3.5 h-3.5 mt-0.5 text-primary shrink-0" />
          <div className="text-xs">
            <p className="font-medium">
              {end.endereco}{end.numero && `, ${end.numero}`}
            </p>
            {end.bairro && <p className="text-muted-foreground">{end.bairro}</p>}
            {end.complemento && <p className="text-muted-foreground italic">{end.complemento}</p>}
            {end.cep && <p className="text-muted-foreground">CEP: {end.cep}</p>}
          </div>
        </div>
      )}

      {!isMesa && selo && (
        <div className="flex items-center gap-2 pt-1">
          <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium flex items-center gap-0.5 ${selo.cor}`}>
            <selo.Icon className="w-3 h-3" /> {selo.label}
          </span>
        </div>
      )}
    </div>
  );
}
